import { useState, useRef } from "react";
import { BsInfoCircle } from "react-icons/bs";


/* =======================
   ENUM
======================= */
export enum CalendarEventMeetingType {
    TASK = "TASK",
    COMPLIANCE = "COMPLIANCE",
    SUPERVISION = "SUPERVISION",
    // TRAINING = "TRAINING",
    // PTO = "PTO",
    GENERIC = "GENERIC",

}

/* =======================
   CONFIG
======================= */
const meetingTypeConfig: Record<
    CalendarEventMeetingType,
    { label: string; color: string }
> = {
    TASK: { label: "Task", color: "#8B5CF6" },
    COMPLIANCE: { label: "Compliance", color: "#EF4444" },
    SUPERVISION: { label: "Supervision", color: "#3B82F6" },
    // TRAINING: { label: "Training", color: "#F59E0B" },
    // PTO: { label: "PTO", color: "#6B7280" },
    GENERIC: { label: "Generic", color: "#14B8A6" },
};

/* =======================
   COMPONENT
======================= */
const MeetingTypeInfoTooltip = () => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    // const Close = IoClose as any;
    const InfoCircle = BsInfoCircle as any;

    return (
        <div ref={containerRef} className="relative inline-block">
            {/* INFO ICON */}
            <button
                onClick={() => setOpen((prev) => !prev)}
                className="text-gray-500 hover:text-gray-700 mt-2.5"
            >
                <InfoCircle size={18} />{""}
            </button>

            {/* TOOLTIP */}
            {open && (
                <div className="absolute left-1/2 top-full z-50 w-36 -translate-x-1/2 rounded-md border bg-white p-3 shadow-lg">
                    {/* Arrow */}
                    <div className="absolute -top-1 left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 bg-white border-l border-t" />

                    {/* Content */}
                    <div className="space-y-2">
                        {Object.values(meetingTypeConfig).map(({ label, color }) => (
                            <div key={label} className="flex items-center gap-2 text-sm">
                                <span
                                    className="h-3 w-3 rounded-full"
                                    style={{ backgroundColor: color }}
                                />
                                <span className="text-gray-700">{label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MeetingTypeInfoTooltip;
